import axios from 'axios'
import * as types from '../mutation-types'

import {
  checkVariable,
} from '../../plugins/helper'

// state
export const state = {
  loading: false,
  authorize: null,
  error: null,
}

// mutations
export const mutations = {
  [types.IS_AUTHENTICATED_START] (state) {
    state.loading = true
    state.authorize = null
    state.error = null
  },

  [types.IS_AUTHENTICATED_SUCCESS] (state, { check }) {
    if (checkVariable(check) && checkVariable(check[1])) {
      state.loading = false
      state.authorize = check[1]
      state.error = null
    }
  },

  [types.IS_AUTHENTICATED_ERROR] (state, error) {
    state.loading = false
    state.authorize = null
    state.error = error
  },
}

// actions
export const actions = {
  async isAuthorized ({ commit }) {
    try {
      commit(types.IS_AUTHENTICATED_START)

      if (this.getters.authToken) {
        const result = await axios.get('/api/settings/check')

        commit(types.IS_AUTHENTICATED_SUCCESS, { check: result.data.check })
      }
    } catch (e) {
      commit(types.IS_AUTHENTICATED_ERROR, e)
    }
  },
}

// getters
export const getters = {
  authorize: state => state.authorize,
}
